import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";

const MenuToggler = ({ menuExpanded, setMenuExpanded }) => {
  return (
    <button
      className="hamburger"
      aria-expanded={menuExpanded}
      onClick={() => setMenuExpanded(!menuExpanded)}
    >
      {menuExpanded ? (
        <FontAwesomeIcon icon={faXmark} size="2xl" className="icon" />
      ) : (
        <FontAwesomeIcon icon={faBars} size="2xl" className="icon" />
      )}
    </button>
  );
};

export default MenuToggler;
